/**
 * Due to the cyclical nature between models and helpers, default values for schemas (i.e. for refine/superRefine)
 * should live in this file.
 */
export const DEFAULT_PIN_THEME_ID = '1';
